<template>
  <div class="onboarding_container">
    <div class="onboarding_initial_form">
      <ElectronInvisibleHeader v-if="isElectronApp" />
      <VerifyEmailCodeForm />
    </div>
  </div>
</template>

<script>
import preloadAppResources from '@/mixins/preloadAppResources';
import VerifyEmailCodeForm from '@/components/elements/authentication/VerifyEmailCodeForm';
import ElectronInvisibleHeader from '../../widgets/ElectronInvisibleHeader.vue';
import electronHelpersMixin from '@/mixins/electronHelpersMixin';

export default {
  name: 'VerifyEmail',
  components: {
    VerifyEmailCodeForm,
    ElectronInvisibleHeader,
  },
  mixins: [preloadAppResources, electronHelpersMixin],
  mounted() {
    this.$nextTick(() => {
      this.onPageLoad();
    });
  },
};
</script>
